import { render, staticRenderFns } from "./FormMatrix.vue?vue&type=template&id=20b3e8d0&scoped=true&"
import script from "./FormMatrix.vue?vue&type=script&lang=js&"
export * from "./FormMatrix.vue?vue&type=script&lang=js&"
import style0 from "./FormMatrix.vue?vue&type=style&index=0&id=20b3e8d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3e8d0",
  null
  
)

export default component.exports